import styled from 'styled-components';
import SectionCard from '../../../components/SectionCard/SectionCard';

export const StyledSectionCard = styled(SectionCard)`
  display: block;
`;
